import { useNavigate } from 'react-router-dom';

const Logout = () => {
    const navigate=useNavigate()
    localStorage.removeItem('key');
    navigate('/login')

}

export default Logout